import AppConfig from 'constants/AppConfig';
import { NotificationManager } from 'react-notifications';
import IntlMessages from 'utils/intl-messages';

interface InvalidInput {
  [key: string]: boolean;
}

export const catchError = {
  checkUnique: (path: string | undefined, invalidInput: InvalidInput, message: string): boolean => {
    NotificationManager.error(
      <IntlMessages id={`global.errors.${path !== undefined ? path : message}.unique`} />,
      <IntlMessages id={`${AppConfig.errorTitle}`} />,
      AppConfig.errorNotificationTimeout
    );
    if (path) {
      invalidInput[path] = true;
    }
    return true;
  },
};
